<script lang="ts">
    import { STATUS } from "@/constants/statuses";

    import T from "@components/T.svelte";

    export let leaveReviewStatus: STATUS;
    export let leaveReviewError: Error | null;
    export let isAuthenticated: boolean;
    export let isPublished: boolean;
    export let isTestReview: boolean;
</script>

<div class="gw-rv-form-result-success">
    <div class="gw-rv-form-result-success__header">
        {#if isTestReview}
            <p class="gw-rv-form-result-success__success-title">
                <T
                    namespace="reviews.ReviewsFormModalWidget"
                    translationKey="test_review_success_message"
                />
            </p>
        {:else if leaveReviewStatus === STATUS.READY}
            <p class="gw-rv-form-result-success__success-title">
                {#if isPublished && isAuthenticated}
                    <T
                        namespace="reviews.ReviewsFormModalWidget"
                        translationKey="authorized_added_review_autopublished_success_message"
                    />
                {:else if !isAuthenticated}
                    <T
                        namespace="reviews.ReviewsFormModalWidget"
                        translationKey="guest_added_review_success_message"
                    />
                {:else}
                    <T
                        namespace="reviews.ReviewsFormModalWidget"
                        translationKey="authorized_added_review_success_message"
                    />
                {/if}
            </p>

            <div class="gw-rv-form-result-success__success-animation">
                <svg
                    class="gw-rv-form-result-success__checkmark"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                >
                    <circle
                        class="gw-rv-form-result-success__checkmark-circle"
                        cx="26"
                        cy="26"
                        r="25"
                        fill="none"
                    />
                    <path
                        class="gw-rv-form-result-success__checkmark-check"
                        fill="none"
                        d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    />
                </svg>
            </div>
        {:else if leaveReviewStatus === STATUS.ERROR}
            <p class="gw-rv-form-result-success__error-title">
                {#if leaveReviewError?.message}
                    {leaveReviewError?.message}
                {:else}
                    <T
                        namespace="reviews.ReviewsFormModalWidget"
                        translationKey="something_went_wrong"
                    />
                {/if}
            </p>
        {/if}
    </div>
</div>

<style lang="postcss">
    .gw-rv-form-result-success {
        &__success-title {
            font-size: 1.25em;
            margin: 0;
            padding: 0 3em;
            text-align: center;
        }

        &__error-title {
            font-size: 1.25em;
            margin: 0;
            padding: 0 3em;
            color: var(--gw-error-color);
            text-align: center;
        }

        &__success-animation {
            margin-top: 3em;
        }

        &__checkmark {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            display: block;
            stroke-width: 2;
            stroke: #4bb71b;
            stroke-miterlimit: 10;
            box-shadow: inset 0px 0px 0px #4bb71b;
            animation: fill 0.4s ease-in-out 0.4s forwards,
                scale 0.3s ease-in-out 0.9s both;
            position: relative;
            top: 5px;
            right: 5px;
            margin: 0 auto;
        }

        &__checkmark-circle {
            stroke-dasharray: 166;
            stroke-dashoffset: 166;
            stroke-width: 2;
            stroke-miterlimit: 10;
            stroke: #4bb71b;
            fill: #fff;
            animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
        }

        &__checkmark-check {
            transform-origin: 50% 50%;
            stroke-dasharray: 48;
            stroke-dashoffset: 48;
            animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
        }
    }

    @keyframes -global-stroke {
        100% {
            stroke-dashoffset: 0;
        }
    }

    @keyframes -global-scale {
        0%,
        100% {
            transform: none;
        }

        50% {
            transform: scale3d(1.1, 1.1, 1);
        }
    }

    @keyframes -global-fill {
        100% {
            box-shadow: inset 0px 0px 0px 30px #4bb71b;
        }
    }
</style>
